import React from 'react';
import { Link } from 'react-router-dom';
import { Car, Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0a1628] border-t border-[#1a2d47]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://res.cloudinary.com/dby6n4go0/image/upload/v1769619796/wehaveyourcar/logo.png" 
                alt="We Have Your Car" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-[#a8b8d0] mb-4">
              Your trusted source for quality used vehicles in Austin, TX. We offer flexible financing options to help you drive away in your dream car.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/wehaveyourcarATX" target="_blank" rel="noopener noreferrer" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/wehaveyourcar" target="_blank" rel="noopener noreferrer" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/inventory" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Browse Inventory
                </Link>
              </li>
              <li>
                <Link to="/credit-application" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Apply for Financing
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/referral-program" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Refer & Earn $100
                </Link>
              </li>
              <li>
                <Link to="/discovery-faqs" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Discovery FAQs
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/sms-terms" className="text-[#a8b8d0] hover:text-[#ff6b35] transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-[#a8b8d0]">
                <Phone size={16} className="text-[#ff6b35]" />
                <a href="tel:5126660016" className="hover:text-white transition-colors">
                  (512) 666-0016
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#a8b8d0]">
                <Mail size={16} className="text-[#ff6b35]" />
                <a href="mailto:info@wehaveyourcar.com" className="hover:text-white transition-colors">
                  info@wehaveyourcar.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#a8b8d0]">
                <MapPin size={16} className="text-[#ff6b35] mt-1" />
                <span>8203 Bluff Springs Rd, Unit 4<br />Austin, TX 78744</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-semibold mb-4">Business Hours</h4>
            <ul className="space-y-2 text-[#a8b8d0]">
              <li className="flex justify-between">
                <span>Monday - Saturday</span>
                <span>10AM - 6PM</span>
              </li>
              <li className="flex justify-between">
                <span>Sunday</span>
                <span>Closed</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-[#22c55e]">
              <Clock size={16} />
              <span className="text-sm">Open Now</span>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1a2d47] mt-8 pt-8 text-center text-[#a8b8d0] text-sm">
          <p>&copy; {new Date().getFullYear()} We Have Your Car. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
